import { Col, InputNumber, Row, Select } from "antd"
import React, { useMemo } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"
import "./styled.scss"
import { debounce } from "lodash"

const Filter = ({ setFilter, tabStatus, setStatus }) => {
  const debouncedSetStartAmount = useMemo(
    () =>
      debounce(value => {
        setFilter(prev => ({ ...prev, start_amount: value }))
      }, 600),
    [setFilter],
  )

  // Debounce cho end_amount
  const debouncedSetEndAmount = useMemo(
    () =>
      debounce(value => {
        setFilter(prev => ({ ...prev, end_amount: value }))
      }, 600),
    [setFilter],
  )
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        marginBottom: 16,
        gap: 12,
        width: "100%",
        flexWrap: "wrap",
        height: "100%",
        marginTop: 16,
      }}
    >
      <Select
        className="uniform-input"
        placeholder="Trạng thái"
        allowClear
        style={{
          width: 160,
          // height: 40,
          // display: "flex",
          // alignItems: "center",
        }}
        onChange={val => setFilter(prev => ({ ...prev, status: val }))}
      >
        <Select.Option value={0}>Chờ duyệt</Select.Option>
        <Select.Option value={1}>Đã duyệt</Select.Option>
        <Select.Option value={2}>Từ chối</Select.Option>
      </Select>

      <SelectCustomer
        style={{
          width: 160,
          // height: 36,
          // display: "flex",
          // alignItems: "center",
        }}
        onChange={val => setFilter(prev => ({ ...prev, customer_id: val }))}
      />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <InputNumber
            placeholder="Số tiền giao dịch tối thiểu"
            onChange={val => debouncedSetStartAmount(val)}
            formatter={value =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={value => value.replace(/,/g, "")}
            onKeyPress={e => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault()
              }
            }}
          />
          <span style={{ fontSize: 16 }}>~</span>
          <InputNumber
            placeholder="Số tiền giao dịch tối đa"
            onChange={val => debouncedSetEndAmount(val)}
            formatter={value =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={value => value.replace(/,/g, "")}
            onKeyPress={e => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault()
              }
            }}
          />
        </div>
      </div>
      <CustomRangePicker
        className="uniform-input"
        style={{
          width: 250,
          // height: 36,
          display: "flex",
          alignItems: "center",
        }}
        format="DD/MM/YYYY"
        onChange={dates => {
          const [start, end] = dates || []
          setFilter(prev => ({
            ...prev,
            start_date: start?.format("YYYY-MM-DD"),
            end_date: end?.format("YYYY-MM-DD"),
          }))
        }}
      />
    </div>
  )
}

export default Filter
